import Model from "./base/model";

class PanelNotification extends Model {
  resourceName() {
    return "panel_notifications";
  }

  fields() {
    return {
      user_id: "",
      title: "",
      notification: "",
      link: "",
      read: "",
      created_at: "",
      user: "",
    };
  }

  async get(filters) {

    return this.request(
      this.resourceName(),
      "GET",
      filters
    );


  }
  async getId(id, filters) {

    return this.request(
      this.resourceName() + `/${id}`,
      "GET",
      filters
    );

  }

  async deals(id) {
    return this.request(
      this.resourceName() + "/deals/" + id,
      "POST",
      {},
      {}
    );
  }

}

export default new PanelNotification();
